module.exports = __webpack_public_path__ + "img/green-star-right.64952feb.png";